import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import CareersLandingPageBlockData from '../../../Models/Content/CareersLandingPageBlockData';
import CareersLanding from './CareersLandingPage';

export default class CareersLandingPage extends EpiComponent<CareersLandingPageBlockData> {
  public render(): ReactNode | ReactNodeArray | null {

    return <CareersLanding data={this.props.data} context={this.props.context}/>;
  }
}
